var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("h3", { staticClass: "headline mb-0" }, [_vm._v("Recycle Bin")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { text: "", icon: "", color: "grey lighten-1" },
              on: { click: _vm.refreshDeletedUsers },
            },
            [_c("v-icon", [_vm._v("fas fa-sync")])],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              "append-icon": "fal fa-search",
              placeholder: "Search",
              "single-line": "",
              "hide-details": "",
              clearable: "",
            },
            model: {
              value: _vm.searchDeleted,
              callback: function ($$v) {
                _vm.searchDeleted = $$v
              },
              expression: "searchDeleted",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.deletedUsers,
          search: _vm.searchDeleted,
          "show-select": "",
          options: _vm.pagination,
          loading: _vm.loading,
        },
        on: {
          "update:options": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.name",
            fn: function ({ item }) {
              return [
                _c(
                  "td",
                  [
                    _vm._v(
                      "\n         " +
                        _vm._s(item.name) +
                        "\n          \n         "
                    ),
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  item.collectionAgent
                                    ? _c(
                                        "v-icon",
                                        _vm._g({ attrs: { small: "" } }, on),
                                        [_vm._v("fal fa-folders")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_vm._v(" "), _c("span", [_vm._v("Collection Agent")])]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "item.roles",
            fn: function ({ item }) {
              return [_c("td", [_vm._v(_vm._s(_vm.formatRoles(item.roles)))])]
            },
          },
          {
            key: "item.updatedDate",
            fn: function ({ item }) {
              return [
                _c("td", [
                  _vm._v(_vm._s(_vm.formatDateTime(item.updatedDate))),
                ]),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "td",
                  { staticClass: "actions" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        staticStyle: {
                                          height: "0px",
                                          width: "0px",
                                          "padding-right": "2px",
                                        },
                                        attrs: { text: "", icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.undelete(item.id)
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: { "font-size": "18px" },
                                          attrs: { color: "grey lighten-1" },
                                        },
                                        [_vm._v("fas fa-trash-restore")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_vm._v(" "), _c("span", [_vm._v("Restore")])]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            {
              attrs: { disabled: !_vm.selected.length },
              on: { click: _vm.undeleteSelected },
            },
            [_vm._v("Restore Selected")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }